<template>
  <div>
    <div class="col-12 pr-0 flex rating">
      <div class="col-2 rating-grade">
        <span class="rating-avg">
          {{ ratings[0].rating }}
        </span>
        <span class="text-uppercase rating-sub">
          out of 5
        </span>
      </div>
      <div class="col-4 flex star-ratings">
        <div class="flex flex-column">
          <span class="rating-heading">Service value</span>
          <span class="rating-heading">Communication</span>
          <span class="rating-heading">Punctuality</span>
          <span class="rating-heading">Mover commitment</span>
          <span class="rating-heading">Customer service</span>
        </div>
        <div class="flex flex-column">
          <star-rating :rating="ratings[0].value"
                       :star-size="15"
                       :show-rating="false"
                       :increment="0.1"
                       :read-only="true"
                       style="line-height: 0;"
          />
          <star-rating :rating="ratings[0].communication"
                       :star-size="15"
                       :show-rating="false"
                       :increment="0.1"
                       :read-only="true"
          />
          <star-rating :rating="ratings[0].punctuality"
                       :star-size="15"
                       :show-rating="false"
                       :increment="0.1"
                       :read-only="true"
          />
          <star-rating :rating="ratings[0].commitment"
                       :star-size="15"
                       :show-rating="false"
                       :increment="0.1"
                       :read-only="true"
          />
          <star-rating :rating="ratings[0].customer_service"
                       :star-size="15"
                       :show-rating="false"
                       :increment="0.1"
                       :read-only="true"
          />
        </div>
      </div>
      <div class="col-6 flex pt-3">
        <div class="rating-grade-wrap col-6">
          <p class="customer-review">
            <read-more more-str="Show more" v-if="ratings[0].body" :text="ratings[0].body" less-str="Show less" :max-chars="300" />
          </p>
        </div>
        <template v-if="!ratings[0].reply && !ratings[0].reply_at && $_can('companies.ratings.update-reply')">
          <div class="col-6 flex justify-content-end align-items-start">
            <button class="btn btn-primary" @click="showReply = true">
              Reply to Customer Review
            </button>
          </div>
        </template>
        <template v-else>
          <div class="col-6">
            <h5 class="text-secondary">Company response:</h5>
            <p class="customer-review text-break">
              <read-more more-str="Show more" v-if="ratings[0].reply" :text="ratings[0].reply" less-str="Show less" :max-chars="300" />
            </p>
          </div>
        </template>
      </div>
    </div>
    <company-rating-reply-modal v-if="showReply" :rating="ratings[0]" @close="closeReply" />
  </div>
</template>

<script>
import CompanyRatingReplyModal from './modals/CompanyRatingReplyModal.vue';

export default {
  components: { CompanyRatingReplyModal },
  props: {
    ratings: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showReply: false,
  }),
  methods: {
    closeReply() {
      this.showReply = false;
      this.$emit('getJob');
    },
  },
};
</script>

<style lang="scss">
.rating {
  background-color: #f9fafc;
}
.rating-grade {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 11px 0 10px 0;
}
.rating-avg {
  color: #4c5669;
  font-size: 55px;
  max-height: 73px;
}
.rating-sub {
  font-size: 10px;
}
.rating-heading {
  font-size: 13px;
  color: #8f8f8f;
}
.star-ratings {
  padding: 14px 24px 10px 14px;
  justify-content: space-evenly;
}
.customer-review {
  & p {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #6d7a86;
    margin-bottom: 12px;
    display: inline;
  }

  & a {
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobRating.vue